/**
 * Created by Pradeep Kumar on 05/20/2019.
 */

import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {TombOfNefertitiReelController} from "../reel/reel/TombOfNefertitiReelController";
import {TombOfNefertitiParsedGameData} from "../server/data/TombOfNefertitiParsedGameData";
import {TombOfNefertitiGameMode} from "../gamemode/TombOfNefertitiGameMode";
import {TweenLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TombOfNefertitiGameConfig} from "../TombOfNefertitiGameConfig";

export class TombOfNefertitiSpinEvent {
    public static readonly ADD_DELAY_IN_START_SPIN: string = "tombOfNefertitiSpinEvents_addDelayInStartSpin";
    public static readonly RESET_SHOW_RESPIN_FLAG: string = "tombOfNefertitiSpinEvents_resetShowReSpinFlag";
}

export class TombOfNefertitiSpinController extends SpinController {

    private _stickySymbols: boolean[];
    private _canShowReSpinWinAmount: boolean = false;

    constructor() {
        super();

        EventHandler.addEventListener(this, TombOfNefertitiSpinEvent.ADD_DELAY_IN_START_SPIN, (event: GameEvent) => this.addDelayInSpinStart(event.params[0]));
        EventHandler.addEventListener(this, TombOfNefertitiSpinEvent.RESET_SHOW_RESPIN_FLAG, () => this._canShowReSpinWinAmount = false);
    }

    /**
     * @description This method tells us which reels to spin during respin.
     */
    protected getReelsGameConfigFromPreviousGameData(): boolean[] {
        let config: boolean[] = super.getReelsGameConfigFromPreviousGameData();

        if (this._mode === TombOfNefertitiGameMode.RESPIN || this._mode === TombOfNefertitiGameMode.RESPIN_FREESPIN) {
            config = this._stickySymbols;
        }
        return config;

    }

    protected parseGameData(data: TombOfNefertitiParsedGameData): void {
        this._stickySymbols = data.respinPositions ? data.respinPositions.reduce((acc, currEl) => acc.concat(<any>currEl), []) : []; // need to type cast it as this reduce will not work directly on boolean.
    }

    protected startSpin(): void {
        if (this._canShowReSpinWinAmount && TombOfNefertitiGameConfig.instance.SPIN_DELAY) {
            TweenLite.to(() => {}, TombOfNefertitiGameConfig.instance.SPIN_DELAY, {
                onComplete: () => {
                    EventHandler.dispatchEvent(new GameEvent("FORCE_HIDE_TOTAL_WIN"));
                }
            });
            EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiReelController.ADD_SPIN_START_DELAY, 0, TombOfNefertitiGameConfig.instance.SPIN_DELAY));
        }
        super.startSpin();
        this._canShowReSpinWinAmount = false;
    }

    private addDelayInSpinStart(delay: number): void {
        this._canShowReSpinWinAmount = true;
        TombOfNefertitiGameConfig.instance.SPIN_DELAY = delay;
    }

    // #359 fix
    protected getSpinTime(): number {
        let retVal: number = super.getSpinTime();

        if (this._mode.indexOf("RESPIN") !== -1) {
            retVal *= 0.5;
        }
        return retVal;
    }
}
